import { render, staticRenderFns } from "./UiSearchItem.vue?vue&type=template&id=e8e2d7ee&"
import script from "./UiSearchItem.vue?vue&type=script&lang=js&"
export * from "./UiSearchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports